import { render } from "./wokerDetail3.vue?vue&type=template&id=240e733c&scoped=true"
import script from "./wokerDetail3.vue?vue&type=script&lang=js"
export * from "./wokerDetail3.vue?vue&type=script&lang=js"

import "./wokerDetail3.vue?vue&type=style&index=0&id=240e733c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240e733c"]])

export default __exports__